import { useEffect, useState } from 'react'
import { SETTINGS_TYPES } from '@/constant'
import { SettingsService } from '@/services/SettingsService'
import { isCrmSettingEnabled } from '@pages/Admin/CRM/components/LeadProfileModal/LeadRefetchContext/leadRefetch.utils'

/** `generalCRMSettings_multipleDealsEnabled` для каскада стикера «Лид». */
export const useCrmMultipleDealsEnabled = () => {
  const [multipleDealsEnabled, setMultipleDealsEnabled] = useState(false)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      let settings = await SettingsService.getCorrected(SETTINGS_TYPES.CRM)

      if (
        settings &&
        !('generalCRMSettings_multipleDealsEnabled' in settings)
      ) {
        localStorage.removeItem(SETTINGS_TYPES.CRM)
        settings = await SettingsService.getCorrected(SETTINGS_TYPES.CRM)
      }

      if (cancelled) return

      setMultipleDealsEnabled(
        isCrmSettingEnabled(settings?.generalCRMSettings_multipleDealsEnabled),
      )
      setReady(true)
    }

    void load()

    return () => {
      cancelled = true
    }
  }, [])

  return { multipleDealsEnabled, ready }
}
